
import Catalogo from "@/mixins/catalogo";
import RULES from "@/mixins/rules";
import { cesionDerecho } from "@/models/cesionDerecho";
import cesionDerechosService from "@/services/cesionDerechosService";
import EstablecimientoService from '@/services/EstablecimientoService';

import SolicitudArrendamientoService from '@/services/SolicitudArrendamientoService';

import {mapGetters} from "vuex";
export default Catalogo.extend({
    name: "FormCesionDerechoExterno",
    mixins: [RULES],
    data() {
        return {
            mercados: [],
            formdata: new cesionDerecho(),
            showInputSolid: false,
            showInputSolidAnt: false,
            showInputFotoC: false,
            showInputBaja: false,
            showInputAlta: false,
            showInputBajaLicencia:false,
            documento: Document || null,
            dialogPdfView:false,
            establecimientos:[] as any,
            
        };
    },
    computed: {
        ...mapGetters({
            usuario: "usuario",
            id: "id",
            contribuyente: "contribuyente",
            mini: "sidebar",
        }),
    },
    methods: {
        async viewpdf(id: any,titulo: any) {
      const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

      let file = new Blob([response.data],{type: response.headers['content-type']});
      const url = window.URL.createObjectURL(file);
      this.documento = {
                    //@ts-ignore
                    title: titulo,
                    url: url,
                    mime: response.headers['content-type']
                }
              this.dialogPdfView=true;
      //window.open(url, '_blank', 'noreferrer');
    },
    async getLocacion() {
            let { data } = await SolicitudArrendamientoService.getLocacion(this.contribuyente.id);
            this.establecimientos = data
        },
        async getData() {
            await cesionDerechosService.getSubTipoLocal().then((response) => {
                this.mercados = response.data;
            });
            if(this.formdata.id_solicitud>0){
                this.showInputSolid = false;
            }
            if(this.formdata.id_solicitud_ant>0){
                this.showInputSolidAnt = false;
            }
            if(this.formdata.id_foto_cesionario >0){
                this.showInputFotoC = false;
            }
            if(this.formdata.id_baja_sat>0){
                this.showInputBaja = false;
            }
            if(this.formdata.id_alta_sat>0){
                this.showInputAlta = false;
            }
            if(this.formdata.baja_form_licen_concesionario>0){
                this.showInputBajaLicencia = false;
            }
            this.getLocacion();
        },
        setDocument(e: any, type: number) {
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                var file = fileReader.result;
                if (type == 1)
                //@ts-ignore
                this.formdata.docSolicitud = file + "";
                if (type == 2)
                //@ts-ignore
                this.formdata.docSolicitudAnt = file + "";
                if (type == 3)
                //@ts-ignore
                this.formdata.docFoto = file + "";
                if (type == 4)
                //@ts-ignore
                this.formdata.docBajaSat = file + "";
                if (type == 5)
                //@ts-ignore
                this.formdata.docAltaSat = file + "";
                if (type == 6)
                //@ts-ignore
                this.formdata.docBaja_form_licen_concesionario = file + "";
        });
        if (e != null)
        fileReader.readAsDataURL(e);
        },
        cancelChangeFile(file: any) {
      if (file == 1)
        this.showInputSolid = false;

        if (file == 2)
        this.showInputSolidAnt = false;

        if (file == 3)
        this.showInputFotoC = false;

        if (file == 4)
        this.showInputBaja = false;

        if (file == 5)
        this.showInputAlta = false;

        if (file == 6)
            this.showInputBajaLicencia = false;
    },
    changeFile(file: any) {
        if (file == 1)
        this.showInputSolid = true;

        if (file == 2)
        this.showInputSolidAnt = true;

        if (file == 3)
        this.showInputFotoC = true;

        if (file == 4)
        this.showInputBaja = true;

        if (file == 5)
        this.showInputAlta = true;

        if (file == 6)
            this.showInputBajaLicencia = true;
    },
    },
    watch: {
    dialog(val) {
      if(this.dialog) {
        this.getData();
      }
    }
  },
    mounted() {
        this.getData();
    },
});
